export default __webpack_public_path__ + "css/supplierViewPurchaseOrder.bundle.css";